import React from 'react';
import { Multiselect } from 'AWS-UI-Components-React';

/**
 * Component to select the column sets i.e. 'All Columns - Component', 
 * 'Total Accuracy - AV', etc. on the component report page.
 */
export class ColumnSetSelector extends React.Component {
  deriveOptions = (columnSets) => {
    return columnSets.map((set) => {
      const { id, label, columns } = set;
      return { id, label, columns };
    });
  };

  render() {
    const { columnSets, placeholder, onChange, selectedColumnSets } = this.props;

    const options = this.deriveOptions(columnSets);
    const selectedOptions = options.filter((op) => (selectedColumnSets || []).includes(op.id));

    return (
      <div id="benchmark-filter">
        <Multiselect
          data-cy="benchmark-selection"
          options={options}
          placeholder={placeholder}
          onChange={onChange}
          selectedOptions={selectedOptions}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/components/columnset_selector.js